import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Image from '@img/rob.png';

const containerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  backgroundColor: '#f5f7fa'
};

const contentWrapper = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '80%'
};

const textSection = {
  flex: 1,
  textAlign: 'center'
};

const imageSection = {
  flex: 1,
  textAlign: 'center'
};

const titleStyle = {
  fontSize: '80px',
  color: '#7d8793',
  margin: '0'
};

const subTitleStyle = {
  fontSize: '22px',
  color: '#4a4a4a',
  margin: '10px 0'
};

const descStyle = {
  fontSize: '18px',
  color: '#5f6c80',
  marginBottom: '30px',
  marginTop: '10px',
  lineHeight: '1.6',
  fontWeight: '500'
};

const buttonStyle = {
  backgroundColor: '#4c6ef5',
  color: '#fff',
  border: 'none',
  padding: '10px 25px',
  borderRadius: '20px',
  cursor: 'pointer',
  fontSize: '14px'
};

function StatusMessage({ title, subTitle, description, showBackButton }) {
  return (
    <div style={containerStyle}>
      <div style={contentWrapper}>
        {/* LEFT TEXT */}
        <div style={textSection}>
          {title && <h1 style={titleStyle}>{title}</h1>}
          {subTitle && <h3 style={subTitleStyle}>{subTitle}</h3>}
          {description && <p style={descStyle}>{description}</p>}

          {showBackButton && (
            <Link to="/admin">
              <button type="button" style={buttonStyle}>
                BACK HOME
              </button>
            </Link>
          )}
        </div>

        {/* RIGHT IMAGE */}
        <div style={imageSection}>
          <img src={Image} alt="robot" style={{ maxWidth: '300px' }} />
        </div>
      </div>
    </div>
  );
}

StatusMessage.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  description: PropTypes.string,
  showBackButton: PropTypes.bool
};

StatusMessage.defaultProps = {
  showBackButton: true
};

export default StatusMessage;
